import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import NewsDetailsSection from './blog-components/news-details';
import Footer from './global-components/footer';
import BlogContact from '../utils/blogContact';

const NewsDetails = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="News Details" />
        <NewsDetailsSection />
        <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
        <Footer />
    </div>
}

export default NewsDetails

